var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-images-wrapp" }, [
    _c(
      "div",
      {
        staticClass:
          "input-images-grid grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-10",
      },
      [
        _c("input", {
          staticClass: "absolute opacity-0 -z-10 pointer-events-none peer",
          attrs: {
            id: "inputImage",
            type: "file",
            multiple: "",
            size: _vm.maxSize,
          },
          on: { change: _vm.handleChange },
        }),
        _vm._v(" "),
        _vm._l(4, function (n) {
          return _vm.images.length < n
            ? _c(
                "label",
                {
                  key: n,
                  staticClass:
                    "relative flex flex-col items-center justify-center gap-3 px-4 py-3 aspect-[1.4/1] border border-gray/20 hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] hover:rounded-md duration-300",
                  class: n == 4 ? "lg:hidden" : "",
                  attrs: { for: "inputImage" },
                },
                [
                  _c("svg", { staticClass: "w-6 h-6" }, [
                    _c("use", { attrs: { "xlink:href": "#img" } }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "text-xs sm:text-sm whitespace-nowrap" },
                    [_vm._v("Upload Image")]
                  ),
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.images, function (image, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass:
                "relative flex border border-gray/20 px-4 py-3 aspect-[1.4/1] -order-1",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "absolute top-1.5 right-1.5 flex items-center justify-center w-9 h-9 bg-white text-blue outline-none hover:scale-90 group duration-200 z-10",
                  attrs: { type: "button", "aria-label": "Delete image" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteImage(key)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "w-4 h-4 group-hover:scale-110 group-hover:rotate-90 duration-200",
                    },
                    [_c("use", { attrs: { "xlink:href": "#close" } })]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "relative w-full h-full" }, [
                _c("img", {
                  staticClass: "w-full h-full object-cover",
                  attrs: { src: image, alt: "" },
                }),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.images.length < _vm.maxLength
          ? _c(
              "label",
              {
                staticClass:
                  "col-start-1 col-end-3 lg:col-end-4 flex items-center justify-center h-20 border border-gray/20 peer-checked:border-white peer-focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] peer-focus-visible:rounded-md hover:rounded-md duration-300",
                attrs: { for: "inputImage" },
              },
              [_c("p", [_vm._v("Upload more images")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.errorShow
          ? _c(
              "div",
              {
                staticClass:
                  "col-start-1 col-end-3 lg:col-end-4 flex items-center min-h-[80px] border border-red duration-300",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col sm:flex-row items-center justify-between text-center sm:text-left gap-6 sm:gap-10 py-6 sm:py-0 px-8 w-full",
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errorMessage) + "\n        "
                    ),
                    _c(
                      "button",
                      {
                        staticClass:
                          "border border-gray/20 py-2 px-8 hover:rounded-md focus-visible:rounded-md hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] duration-300 outline-none",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.errorShow = false
                          },
                        },
                      },
                      [_vm._v("Okay")]
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }